var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgStarOutline = function SvgStarOutline(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 20 20",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, desc === undefined ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, "Created with Sketch.") : desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10 2.1 1.9 4.7.3.8.9.1 5 .4-3.8 3.5-.6.6.2.9 1.1 5.1-4.2-2.6-.8-.6-.8.5L5 18.1 6.1 13l.2-.9-.6-.6L1.9 8l5-.4.9-.1.3-.8zM10 0c-.2 0-.3 0-.5.1-.3.1-.5.4-.6.6L6.7 6.2l-5.6.5C.5 6.8 0 7.3 0 8c0 .3.2.6.4.8l4.3 3.9-1.3 5.8c-.1.7.2 1.3.9 1.5h.3c.2 0 .4-.1.6-.2l4.9-3.1 4.9 3.1c.2.1.4.2.6.2.4 0 .8-.2 1-.6.2-.3.2-.6.1-.9l-1.3-5.8 4.3-3.9c.5-.4.5-1.2.1-1.7-.2-.2-.5-.4-.8-.4l-5.6-.5L11.2.7C10.9.3 10.5 0 10 0"
  })));
};
export default SvgStarOutline;